<template>
  <div class="cache-setting">


    <div class="text-inputs">
      <loginInput
        :label="$t('settings.cacheType')"
        :bottomTip="$t('settings.cacheTypeTip')"
        tipStyle="color: #A1A7C4;margin-left: -12px;"
        inputStyle="width: 400px; height: 40px;"
        realInputStyle="width: 400px; height: 40px;"
        :inputValue="cacheType"
        @changeInput="(e) => (cacheType = e)"
      />

      <div class="btn-commit" @click="commitClick">
        {{ $t("product.commit") }}
      </div>
    </div>
  
    <div class="text-inputs">
      <loginInput
        :label="$t('settings.cacheTime')"
        :bottomTip="$t('settings.cacheTimeoutTip')"
        tipStyle="color: #A1A7C4;margin-left: -12px;"
        inputStyle="width: 400px; height: 40px;"
        realInputStyle="width: 400px; height: 40px;"
        @changeInput="(e) => (cacheTimeout = e)"
        :inputValue="cacheTimeout"
      />

      <div class="btn-commit" @click="commitClick2">
        {{ $t("product.commit") }}
      </div>
    </div>
  
    <div class="text-inputs">
      <loginInput
        :label="$t('settings.cacheLimit')"
        :bottomTip="$t('settings.cacheLimitTip')"
        tipStyle="color: #A1A7C4;"
        inputStyle="width: 400px; height: 40px;"
        realInputStyle="width: 400px; height: 40px;"
        @changeInput="(e) => (cacheLimit = e)"
        :inputValue="cacheLimit"
      />
      <loginInput
        :label="$t('settings.cacheLimitTTL')"
        :bottomTip="$t('settings.cacheLimitTTLTip')"
        tipStyle="color: #A1A7C4;"
        inputStyle="width: 400px; height: 40px; margin-left: 24px"
        realInputStyle="width: 400px; height: 40px;"
        @changeInput="(e) => (cacheLimitTTL = e)"
        :inputValue="cacheLimitTTL"
      />

      <div class="btn-commit" @click="commitClickAll('cacheLimit')">
        {{ $t("product.commit") }}
      </div>

    </div>
    <!-- <div class="top-inputs" style="margin-top: 25px">
      <loginInput
        :label="$t('product.allRefresh')"
        :bottomTip="$t('product.cacheTip')"
        tipStyle="color: #A1A7C4;margin-left: -12px;"
        inputStyle="width: 400px; height: 40px;"
        realInputStyle="width: 400px; height: 40px;"
        @changeInput="(e) => (allRefresh = e)"
      />

      <div class="btn-commit" @click="commitClick3">
        {{ $t("product.allRefresh") }}
      </div>
    </div> -->
    <div class="switch-inputs">
    <CDNSwitch
      :label="$t('product.forceCache')"
      :tipLabel="$t('product.forceCacheTip')"
      :hasbottomline="false"
      :inValue="clearPath"
      @change="switchChange"
    />
    </div>

    <div class="switch-inputs">
    <CDNSwitch
      :label="$t('settings.closeCache')"
      :tipLabel="$t('settings.closeCacheTip')"
      :hasbottomline="false"
      :inValue="closeCache"
      @change="switchChangeCloseCache"
    />
    </div>

    <div class="text-inputs">
      <loginInput
        :label="$t('settings.keepaliveTime')"
        :bottomTip="$t('settings.keepaliveTimeTip')"
        tipStyle="color: #A1A7C4;margin-left: -12px;"
        inputStyle="width: 400px; height: 40px;"
        realInputStyle="width: 400px; height: 40px;"
        @changeInput="(e) => (keepaliveTime = e)"
        :inputValue="keepaliveTime"
      />

      <div class="btn-commit" @click="commitClickAll('keepaliveTime')">
        {{ $t("product.commit") }}
      </div>
    </div>


    <!-- <CDNSwitch
      :label="'流量缓冲'"
      :tipLabel="'如果出现需要持续流量请求，需要关闭流量缓冲'"
      :hasbottomline="false"
      @change="switchChange2"
    /> -->

    <div class="bottom-btn-group" v-if="this.name=='subhost'">
        <div class="btn-refresh" @click="commitClickAll('pureCache')">{{$t('product.allRefresh')}}</div>
    </div>

  </div>
</template>

<script>
/* eslint-disable */

import { apiCommonEdit, apiGetDetail } from "@/service/requestRes";
export default {
  props: {
    name: String,
    id: Number,
  },
  data() {
    return {
      detail: null,
      remap_config_json: null,
      whiteip_config_json: null,
      blackip_config_json: null,
      cacheType: "",
      cacheTimeout: "",
      clearPath: null,
      cacheLimit: null,
      cacheLimitTTL: null,
      closeCache: null,
      keepaliveTime: "",
    };
  },
  mounted(){
    this.getDetail();
  },
  watch: {
    detail(val) {
      let serverJson1 = {};
      try {
        const { remap_config_json, host_json_server } = val || {};
        if(this.name == "host") {
          serverJson1 = host_json_server && JSON.parse(host_json_server);
        } else {
          serverJson1 = remap_config_json && JSON.parse(remap_config_json);
        }
        const { cache, security, keepaliveTime } = serverJson1 || {};
        const {cacheType, cacheTimeout, closeCache} = cache || {};
        const {clearPath, cacheLimit, cacheLimitTTL} = security || {}
        this.cacheType = cacheType && cacheType.replace(/\\\.\(/g, '').replace(/\)\$/g,'');
        this.cacheTimeout = cacheTimeout && String(cache.cacheTimeout);
        this.clearPath = clearPath;
        this.cacheLimit = cacheLimit && String(security.cacheLimit/1048576);  // to MB
        this.cacheLimitTTL = cacheLimitTTL && String(security.cacheLimitTTL);
        this.closeCache = closeCache;
        this.keepaliveTime = keepaliveTime && String(keepaliveTime);
      } catch(e) {
        console.error(e);
      }
    }
  },
  methods: {
    getDetail() {
      apiGetDetail(
          this.name, this.id
      ).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
            this.detail = data;
        } else {
          this.$message({
            message: msg,
            type: 'error',
          });
        }
      });
    },
    commitClickAll(func_name) {
      let paras = {
        func: func_name
      }
      if (func_name == 'cacheLimit') {
        paras['security'] = {
          cacheLimit : this.cacheLimit,
          cacheLimitTTL : this.cacheLimitTTL
        }
      } else if (func_name == 'cacheType') {
        paras['cache'] = {
          cacheType: this.cacheType
        }
      } else if (func_name == 'keepaliveTime') {
        paras['keepaliveTime'] = this.keepaliveTime;
      } else if (func_name == 'pureCache') {
      } else {
        this.$message({
          message: "unknown func: " + func_name,
          type: "error",
        });
        return;
      }
      this.updateObject(paras);
    },
    commitClick() {
      const cacheType = {
        func: "cacheType",
        cache: {
          cacheType: this.cacheType,
        },
      };
      this.updateObject(cacheType);
    },

    commitClick2() {
      const cacheType = {
        func: "cacheTimeout",
        host: this.domainHost,
        cache: {
          cacheTimeout: this.cacheTimeout,
          useRespMaxAge: false,
        },
      };
      this.updateObject(cacheType);
    },

    commitClick3() {},
    allRefreshClick() {},

    switchChange2(e) {
      const closeBuffering = {
        func: "closeBuffering",
        host: this.domainHost,
        closeBuffering: e,
      };

      this.updateObject(closeBuffering);
    },
    switchChangeCloseCache(e) {
      const clearPath = {
        func: "closeCache",
        cache: {
          closeCache: e,
        },
      };
      this.updateObject(clearPath);
    },
    switchChange(e) {
      const clearPath = {
        func: "clearPath",
        host: this.domainHost,
        security: {
          clearPath: e,
        },
      };

      this.updateObject(clearPath);
    },
    updateObject(obj) {
      if(this.name == "host") {
        obj[this.name] = this.detail.host;
      } else {
        obj[this.name] = this.detail.sub_host;
      }
      apiCommonEdit(this.name, {
        ...obj,
      }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.$message({
            message: this.$t('common.success'),
            type: "success",
          });
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cache-setting {
  padding-bottom: 120px;
  .text-inputs {
    padding-top: 36px;
    display: flex;
    position: relative;
  }
  .switch-inputs {
    padding-top: 8px;
    display: flex;
    position: relative;
  }
  .bottom-btn-group {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 50px;
    .btn-refresh {
      padding: 8px 30px;
      border: 1px solid #d7dbec;
      border-radius: 4px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #5a607f;
      margin-left: 27px;
      cursor: pointer;
    }
  }
}

.btn-commit {
  padding: 0 44px;
  height: 42px;
  line-height: 42px;
  background: #d9e4ff;
  border-radius: 4px;
  font-family: PingFangSC-Semibold;
  font-size: 14px;
  color: #1e5eff;
  cursor: pointer;
  margin-top: 23px;
  margin-left: 20px;
}

.el-input__inner{
  width: 400px;
}

</style>
